// vue
// import { useStore } from 'vuex';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { CourseSchema } from '@/vue3/api/models';

export const useCourseSchemaService = () => {
    // hooks
    const axios = useAxios();

    // properties
    const { courseSchemas, apiUrl } = useStore().state;

    // methods
    const getCourseSchemas = async (): Promise<CourseSchema[]> => {
        const res = await axios.get(`${apiUrl}/course-schema`);
        return res.data;
    };

    const getCourseSchemaList = async (): Promise<CourseSchema[]> => {
        const res = await axios.get(`${apiUrl}/course-schema/list`);
        return res.data;
    };

    const getCourseSchemaByOrganization = async (
        id: number,
    ): Promise<CourseSchema[]> => {
        const res = await axios.get(`${apiUrl}/course-schema/${id}/list`);
        return res.data;
    };

    const getCourseSchemaByRole = async (
        id: number,
    ): Promise<CourseSchema[]> => {
        const res = await axios.get(`${apiUrl}/course-schema/role/${id}/list`);
        return res.data;
    };

    const getPlayerAppCourseSchemaByRole = async (
        id: number,
    ): Promise<CourseSchema[]> => {
        const res = await axios.get(
            `${apiUrl}/playerapp-course-schema/role/${id}/list`,
        );
        return res.data;
    };

    const getCourseSchema = async (id: number): Promise<CourseSchema> => {
        const res = await axios.get(`${apiUrl}/course-schema/${id}`);
        return res.data;
    };

    const createCourseSchema = async (
        courseSchema: CourseSchema,
    ): Promise<CourseSchema> => {
        const res = await axios.post(`${apiUrl}/course-schema`, courseSchema);
        return res.data;
    };

    const updateCourseSchema = async (
        courseSchema: CourseSchema,
    ): Promise<CourseSchema> => {
        const res = await axios.put(`${apiUrl}/course-schema`, courseSchema);
        return res.data;
    };

    const deleteCourseSchema = async (id: number): Promise<CourseSchema> => {
        const res = await axios.deleteId(`${apiUrl}/course-schema/${id}`);
        return res.data;
    };

    const getNumHoles = async (id: number): Promise<number> => {
        const res = await axios.get(`${apiUrl}/course-schema/${id}/num-holes`);
        return res.data;
    };

    const getCourseSubscirptions = async (): Promise<string[]> => {
        const res = await axios.get(`${apiUrl}/course-iaps`);
        return res.data;
    };

    const createPlayerAppSubscriptions = async (
        courseIaps: String[],
    ): Promise<string[]> => {
        const res = await axios.post(`${apiUrl}/course-iaps`, courseIaps);
        return res.data;
    };

    const deletePlayerAppSubscriptions = async (
        courseIaps: String[],
    ): Promise<string[]> => {
        const res = await axios.deleteObject(
            `${apiUrl}/course-iaps`,
            courseIaps,
        );
        return res.data;
    };

    const upLoadPlayerAppCourseImage = async (
        images: any,
    ): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/player-app-course/images`,
            images,
        );
        return res.data;
    };

    const upLoadPlayerAppTeeImage = async (images: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/player-app-tee-photos`, images);
        return res.data;
    };

    return {
        courseSchemas,
        getCourseSchemas,
        getCourseSchemaList,
        getCourseSchema,
        createCourseSchema,
        updateCourseSchema,
        deleteCourseSchema,
        getNumHoles,
        getCourseSchemaByOrganization,
        getCourseSchemaByRole,
        getPlayerAppCourseSchemaByRole,
        getCourseSubscirptions,
        createPlayerAppSubscriptions,
        deletePlayerAppSubscriptions,
        upLoadPlayerAppCourseImage,
        upLoadPlayerAppTeeImage,
    };
};
